import React, { createContext, useContext, useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';

const ManualBookingContext = createContext();

export const useManualBooking = () => {
  const context = useContext(ManualBookingContext);
  if (!context) {
    throw new Error('useManualBooking must be used within a ManualBookingProvider');
  }
  return context;
};

export const ManualBookingProvider = ({ children }) => {
  const { companyData: authCompanyData } = useAuth();
  const [companyData, setCompanyData] = useState(null);

  const [bookingData, setBookingData] = useState({
    companyId: authCompanyData?.id || null,
    selectedLocation: null,
    locationId: null,
    selectedService: null,
    selectedEmployee: null,
    selectedDateTime: null,
    customer: null,
    notes: '',
    date: null,
    startTime: null,
    companyData: null
  });

  useEffect(() => {
    if (!authCompanyData?.id) return;
    const fullCompanyData = { ...authCompanyData, id: authCompanyData.id };
    setCompanyData(fullCompanyData);
    setBookingData((prev) => ({
      ...prev,
      companyId: fullCompanyData.id,
      companyData: fullCompanyData,
    }));
  }, [authCompanyData]);

  const updateBookingData = (updates) => {
    setBookingData((prev) => ({
      ...prev,
      ...updates,
    }));
  };

  const resetBookingData = () => {
    setBookingData({
      companyId: authCompanyData?.id || null,
      selectedLocation: null,
      locationId: null,
      selectedService: null,
      selectedEmployee: null,
      selectedDateTime: null,
      customer: null,
      notes: '',
      date: null,
      startTime: null,
      companyData,
    });
  };

  return (
    <ManualBookingContext.Provider
      value={{
        bookingData,
        updateBookingData,
        resetBookingData,
        companyData,
      }}
    >
      {children}
    </ManualBookingContext.Provider>
  );
};

export default ManualBookingContext;
